import React from 'react'

const SearchBar = (props) => {
    return (
        <div className='search-bar'>
            <input className='d-inline-block' onChange={props.handleChange} placeholder='Search' />
            <div>
                <img src='/images/icon-mag-glass.png' alt='Search' />
            </div>
        </div>
    )
}

export default SearchBar



// WEBPACK FOOTER //
// ./resources/js/elements/SearchBar.js